import React from "react";
import { AuthProvider } from "../../common/hooks/useAuth";
import { LangProvider } from "../../common/hooks/useLang";

export function AppContext(props) {
  return (
    <LangProvider>
      <AuthProvider>{props.children}</AuthProvider>
    </LangProvider>
  );
}
